import { combineReducers } from "redux";
import createReducer from "utils/createReducer";
import {
  FETCH_APPOINTMENT_REASONS_REQUEST,
  FETCH_APPOINTMENT_REASONS_SUCCESS,
  FETCH_APPOINTMENT_REASONS_FAILURE,
  FETCH_PRACTICE_PROFESSIONAL_APPOINTMENT_REASONS_SUCCESS,
} from "./constants";

const byIdSuccess = (state, { response }) =>
  response.entities.appointmentReasons || {};
const allIdsSuccess = (state, { response }) => response.result || [];

const byId = createReducer({})({
  [FETCH_APPOINTMENT_REASONS_SUCCESS]: byIdSuccess,
});

const allIds = createReducer([])({
  [FETCH_APPOINTMENT_REASONS_SUCCESS]: allIdsSuccess,
});

const reasonsLoadingState = createReducer(false)({
  [FETCH_APPOINTMENT_REASONS_REQUEST]: () => true,
  [FETCH_APPOINTMENT_REASONS_SUCCESS]: () => false,
  [FETCH_APPOINTMENT_REASONS_FAILURE]: () => false,
});

const practiceProfessionalAppointmentReasons = createReducer([])({
  [FETCH_PRACTICE_PROFESSIONAL_APPOINTMENT_REASONS_SUCCESS]: (
    state,
    { response }
  ) => response,
});

export const getAppointmentReason = (state, id) => state.byId[id];
export const getAppointmentReasons = (state) => {
  if (state) {
    return state.allIds.map((id) => state.byId[id]);
  }
  return [];
};

export const getReasonsLoadingState = (state) => {
  if (state) {
    return state.reasonsLoadingState;
  }
};

export const getPracticeProfessionalAppointmentReasons = (state) => {
  if (state) {
    return state.practiceProfessionalAppointmentReasons;
  }
};

export default combineReducers({
  byId,
  allIds,
  reasonsLoadingState,
  practiceProfessionalAppointmentReasons,
});
